import { put, race, select, take, takeLatest } from 'redux-saga/effects';
import get from 'lodash/get';

import {
  actions as medicationRefillsActions,
  consts as medicationRefillsConsts,
} from '../patientPortal/medication-refill-req';
import { actions as setPreferredPharmacyActions } from '../patientPortal/set-preferred-pharmacy-req';
import { actions as medicationRefillsHistoryActions } from '../patientPortal/medication-refills-history';
import { actions as getUserActionsActions } from '../../profiles/get-user';

import * as error from '../../ui/error';
import { actions as popupActions } from '../../ui/popup';
import {
  loggedUserIdSelector,
  targetUserIdSelector,
} from '../../context/selectors';

function* handleUpdateUSerProfile() {
  const targetUserId = yield select(targetUserIdSelector);
  const loggedUserId = yield select(loggedUserIdSelector);
  const safeUserId = targetUserId || loggedUserId;
  yield put(getUserActionsActions.send({ id: safeUserId }));
}

function* medicationRefillsSagaWorker({ payload }) {
  yield put(medicationRefillsActions.send(payload));

  const { succeed, rejected } = yield race({
    succeed: take(medicationRefillsConsts.SUCCEED),
    rejected: take(medicationRefillsConsts.REJECTED),
  });

  if (succeed) {
    yield put(popupActions.hide());
    yield put({
      type: error.consts.UPDATE,
      payload: {
        id: 'patient.portal.requestRefillNotification',
      },
      isStaticFlow: true,
      infoErrorIcon: 'information',
    });
    yield put(medicationRefillsHistoryActions.send({ userId: payload.userId }));
  } else {
    const thirdPartyError =
      get(rejected, 'payload.error.code', '') === 'third_party_error';
    if (thirdPartyError) {
      yield put({
        type: error.consts.UPDATE,
        payload: {
          id: 'errors.common',
        },
      });
    }
  }
}

export default function* medicationRefillsSaga() {
  yield takeLatest(medicationRefillsActions.init, medicationRefillsSagaWorker);

  yield takeLatest(
    setPreferredPharmacyActions.succeed,
    handleUpdateUSerProfile,
  );
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/medication-refill-saga.js